import { render, staticRenderFns } from "./FirstStart.vue?vue&type=template&id=122f3816&scoped=true&"
import script from "./FirstStart.vue?vue&type=script&lang=js&"
export * from "./FirstStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122f3816",
  null
  
)

export default component.exports